/*============================================================================
YouTube Video Carousel
==============================================================================*/
$('.youtube-container').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    nextArrow: '.carousel-container .arrow-right i',
    prevArrow: '.carousel-container .arrow-left i'
});


/*============================================================================
Video Reveal for Play Button
==============================================================================*/
var yt_int, yt_players={},
initYT = function() {
   $(".ytplayer").each(function() {
       yt_players[this.id] = new YT.Player(this.id);
   });
};

$.getScript("https://www.youtube.com/player_api", function() {
   yt_int = setInterval(function(){
       if(typeof YT === "object"){
           initYT();
           clearInterval(yt_int);
         }
   },500);
});

$('.close-reveal-modal').on('click tap', function() {
    $('.video-reveal').trigger('reveal:close');
    $('#videoReveal').removeClass('toggleModalClass');
    yt_players["player1"].pauseVideo();
});

$('#mainLanderPlayBtn').on('click tap', function(e) {
    e.preventDefault();
    $('#videoReveal').trigger('reveal:open');
    $('#videoReveal').addClass('toggleModalClass');
    yt_players["player1"].playVideo();
});
